import React, { useState } from "react";
import { useUserContext } from "../../utils/UserContext";
import { tincPermis } from "../../utils/Permisos";
import Seleccionartipusabsencia from "./Seleccionartipusabsencia";
import Detallstipusabsencia from "./Detallstipusabsencia";
import "../dashboard_v2.css";
import AjudaMestres from "./AjudaMestres";
import { BotoAjuda } from "./AjudaModal";

function idTipus(t) {
  return t ? Number(t.idTipusAbsenciaEmpleats) : null;
}

function Tipusabsencia() {
  const { rolUsuari } = useUserContext();
  const potAccedir = tincPermis(rolUsuari, "ACCES", "GESTIO_LABORAL");

  const [activeTab, setActiveTab] = useState("seleccionar");
  const [selectedTipus, setSelectedTipus] = useState(null);
  const [filterText, setFilterText] = useState("");
  const [tipusLlista, setTipusLlista] = useState([]);
  const [reloadToken, setReloadToken] = useState(0);
  const [mostraAjuda, setMostraAjuda] = useState(false);

  const tornarLlista = (refresca = false) => {
    setActiveTab("seleccionar");
    if (refresca) setReloadToken((n) => n + 1);
  };

  const handleTipusSelect = (t) => {
    if (!t) {
      setSelectedTipus(null);
      return;
    }
    setSelectedTipus((prev) => (idTipus(prev) === idTipus(t) ? null : t));
  };

  const obrirFitxa = (t, mode) => {
    setSelectedTipus(t);
    setActiveTab(mode);
  };

  if (!potAccedir) {
    return (
      <div className="dv2 dv2-page">
        <p className="dv2-empty">No tens permisos per accedir a aquesta pantalla.</p>
      </div>
    );
  }

  const esLlista = activeTab === "seleccionar";

  return (
    <div className="dv2 dv2-page dv2-page--fill">
      {mostraAjuda && <AjudaMestres pestanya="tipusabsencia" onTancar={() => setMostraAjuda(false)} />}
      {esLlista ? (
        <>
          <div className="dv2-pageHeader">
            <div className="dv2-pageHeader-main">
              <div className="dv2-pageHeader-icon" aria-hidden="true">
                📅
              </div>
              <div>
                <h1 className="dv2-pageHeader-title">Tipus d'absència</h1>
                <p className="dv2-pageHeader-subtitle">Catàleg d'absències i baixes laborals.</p>
              </div>
            </div>
            <div className="dv2-pageHeader-actions">
              <BotoAjuda title="Com funcionen els Tipus d'absència" onClick={() => setMostraAjuda(true)} />
              {tincPermis(rolUsuari, "CREAR") && (
                <button
                  type="button"
                  className="dv2-btn dv2-btn--primary"
                  onClick={() => {
                    setSelectedTipus(null);
                    setActiveTab("nou");
                  }}
                >
                  Nou tipus
                </button>
              )}
            </div>
          </div>

          <Seleccionartipusabsencia
            onTipusSelect={handleTipusSelect}
            onConsultar={(t) => obrirFitxa(t, "consultar")}
            onModificar={(t) => obrirFitxa(t, "modificar")}
            onEsborrar={(t) => obrirFitxa(t, "esborrar")}
            selectedTipus={selectedTipus}
            setTipusLlista={setTipusLlista}
            filterText={filterText}
            setFilterText={setFilterText}
            reloadToken={reloadToken}
          />
        </>
      ) : (
        <Detallstipusabsencia
          mode={activeTab}
          tipus={activeTab === "nou" ? null : selectedTipus}
          tipusLlista={tipusLlista}
          onNavigate={setSelectedTipus}
          onCancel={() => tornarLlista(false)}
          onDeleted={() => tornarLlista(true)}
          onCanviarMode={setActiveTab}
          onSave={(updated) => {
            if (activeTab === "nou") {
              tornarLlista(true);
              return;
            }
            setSelectedTipus(updated);
            setTipusLlista((prev) =>
              (prev || []).map((t) => (idTipus(t) === idTipus(updated) ? { ...t, ...updated } : t))
            );
            setActiveTab("consultar");
          }}
        />
      )}
    </div>
  );
}

export default Tipusabsencia;
